@layer token {
  :root {
    /* BASE ------------------------------------------------------------------- */

    --n-loader-color: currentColor;

    --n-loader-stroke-width: 2;

    /* SPINNER SIZES ---------------------------------------------------------- */

    --n-loader-spinner-xs-size: var(--n-scale-300); /* 12px */
    --n-loader-spinner-sm-size: var(--n-scale-500); /* 20px */
    --n-loader-spinner-md-size: var(--n-scale-700); /* 28px */
    --n-loader-spinner-lg-size: var(--n-scale-900); /* 36px */
    --n-loader-spinner-xl-size: var(--n-scale-1200); /* 48px */
    --n-loader-spinner-font-size: 1em;
  }
}

@layer component {
  /* ANIMATION ---------------------------------------------------------------- */

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  /* BASE --------------------------------------------------------------------- */

  .loader {
    display: inline-flex;
  }

  /* SPINNER VARIANT ---------------------------------------------------------- */

  .spinnerVariant {
    color: var(--n-loader-color, --n-color-surface-neutral-contrast);
  }

  .spinnerSvg {
    width: var(--n-loader-size);
    height: var(--n-loader-size);
    stroke-width: var(--n-loader-stroke-width);
    animation: spin 0.8s linear infinite;
  }

  /* SIZES -------------------------------------------------------------------- */

  .xsSize {
    --n-loader-size: var(--n-loader-spinner-xs-size);
  }

  .smSize {
    --n-loader-size: var(--n-loader-spinner-sm-size);
  }

  .mdSize {
    --n-loader-size: var(--n-loader-spinner-md-size);
  }

  .lgSize {
    --n-loader-size: var(--n-loader-spinner-lg-size);
    --n-loader-stroke-width: 4;
  }

  .xlSize {
    --n-loader-size: var(--n-loader-spinner-xl-size);
    --n-loader-stroke-width: 6;
  }

  .fontSize {
    --n-loader-size: var(--n-loader-spinner-font-size);
  }
}
